module.exports = __webpack_public_path__ + "static/media/C-PNG.625c4e78.png";